import type { Engajamento } from '@/domain/model/Engajamento';
import type { GetEngajamentoUseCase } from '@/application/port/in/GetEngajamentoUseCase';
import type { EngajamentoGateway } from '@/application/port/out/EngajamentoGateway';

export class GetEngajamento implements GetEngajamentoUseCase {
  constructor(private readonly gateway: EngajamentoGateway) {}
  execute(matriculaId: string): Promise<Engajamento> {
    return this.gateway.fetch(matriculaId);
  }
}
